import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
	MotifModal,
	MotifModalHeader,
	MotifModalBody,
	MotifModalFooter,
	MotifButton,
} from "@ey-xd/motif-react";
import { useLazyDeleteRuleQuery } from "@/services/rules/rulesReducer";
import { CANCEL_BUTTON_VARIANT, CONFIRM_BUTTON_VARIANT } from "@/components/Images/CommonImages";
import { CommonModalHeader } from "@/components/Modal/CommonModalHeader/CommonModalHeader";
import { useTrans } from "@/components/Functions/dateFunc";

interface DeleteRuleProps {
	show: boolean;
	setShow: (value: boolean) => void;
	id: string | undefined;
	setDeleteErrorMessage: (message: string) => void;
	ruleRefetch: () => void;
	classRefetch: () => void;
	deleteEntityName:any
}

const DeleteRule = ({
	show,
	setShow,
	id,
	setDeleteErrorMessage,
	ruleRefetch,
	classRefetch,
	deleteEntityName
}: DeleteRuleProps) => {
	const { t } = useTranslation();
	const [isLoading, setIsLoading] = useState(false);
	const [deleteRule] = useLazyDeleteRuleQuery();

	const handleCancel = () => {
		setShow(false);
		setDeleteErrorMessage("");
	};

	const handleDelete = () => {
		setIsLoading(true);
		setDeleteErrorMessage("");
		deleteRule(id).then((response: any) => {
			if (response.data) {
				ruleRefetch();
				classRefetch();
			} else {
				setDeleteErrorMessage("Error while deleting rule");
			}
			setIsLoading(false);
			setShow(false);
		});
	};
	return (
    <MotifModal
      onClose={handleCancel}
      show={show}
      focusTrapOptions={{
        tabbableOptions: {
          displayCheck: "none",
        },
      }}
    >
      <div className="confirmationModalWrapper creditor_disabling_model">
        <MotifModalHeader headerIcon={CommonModalHeader()}></MotifModalHeader>
        <MotifModalBody style={{ paddingTop: "0px" }}>
          {useTrans(
            t,
            t("pages.configuration.scheme.rule.deleteRuleMessage", {
              ruleName: deleteEntityName,
            }),
            "ruleName"
          )}
        </MotifModalBody>

        <MotifModalFooter>
          <MotifButton
            onClick={handleCancel}
            type={"button"}
            variant={CANCEL_BUTTON_VARIANT}
          >
            {t("pages.configuration.scheme.rule.cancel")}
          </MotifButton>
          <MotifButton
            onClick={handleDelete}
            type={isLoading ? "loader" : "submit"}
            variant={CONFIRM_BUTTON_VARIANT}
            disabled={isLoading}
          >
            {t("pages.configuration.scheme.class.confirm")}
          </MotifButton>
        </MotifModalFooter>
      </div>
    </MotifModal>
  );
};
export default DeleteRule;
